import DOMPurify from 'dompurify'

import * as S from './styled'

const Description = ({ description, type }) => (
  <S.Description
    type={type}
    dangerouslySetInnerHTML={{
      __html: DOMPurify.sanitize(description)
    }}
  />
)

export default Description
